import { Button, createStyles, Grid, makeStyles, Typography } from "@material-ui/core";
import Add from "@material-ui/icons/Add";
import { AddButton } from "../style";

interface IaddItem {
  title?: string;
  onClick?: () => void;
}
const useStyles = makeStyles(() =>
  createStyles({
    container: {
      display: "flex",
      marginBottom: "15px",
      width: "auto",
      textAlign: "center",
    },
    button: {
      height: 30,
      width: 30,
      paddingTop: 5,
      display: " inline-block",
      color: "#399ebf",
      background: "#E1F3FB",
      border: "1px solid #399ebf",
      borderRadius: 2,
      "&:hover": {
        background: "#E1F3FB",
        cursor: "pointer",
      },
    },
    title: {
      color: "#399ebf",
      marginLeft: 10,
      marginTop: 2,
    },
    icon: {
      fontSize: 15,
    },
  })
);

export const AddItem = ({ title, onClick }: IaddItem) => {
  const classes = useStyles();
  return (
    <Grid className={classes?.container} onClick={onClick}>
      <Grid className={classes?.button}>
        <Add className={classes?.icon} />
      </Grid>
      <Typography className={classes?.title}>{title}</Typography>
    </Grid>
  );
};
